import React, { useState } from "react"
import AdresseComponent from "./AdresseComponent"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faChevronDown,
	faChevronUp,
	faEdit,
} from "@fortawesome/free-solid-svg-icons"
import { useSelector } from "react-redux"
import AdresseComponentV2 from "./input/AdresseComponentV2"
import { getBasePointInteret } from "../../utilities/defaultObjects"

const PointInteretComponent = ({
	pointInteret,
	updatePointInteret = null,
	openPointInteret = null,
	list = [POINT_INTERET_TYPE_PARC, POINT_INTERET_TYPE_FOURRIERE],
	showType = true,
}) => {
	const [showAdresse, setShowAdresse] = useState(false)
	const updateAdresse = (key, value, full = false) => {
		if (!updatePointInteret) return
		if (full) {
			updatePointInteret("adresse", value)
		} else {
			let tempAdresse = Object.assign({}, pointInteret.adresse)
			tempAdresse[key] = value
			updatePointInteret("adresse", tempAdresse)
		}
	}
	return (
		<div className={"col flex-center"}>
			<div className={"row full"}>
				{showType && (
					<div className="lab-in">
						<label>Type</label>
						<select
							value={pointInteret.type}
							onChange={(e) =>
								updatePointInteret(
									"type",
									parseInt(e.target.value),
								)
							}
							disabled={!updatePointInteret}
						>
							{list.map((el) => (
								<option key={`pi_${el}`} value={el}>
									{POINTS_INTERETS_DICT[el]}
								</option>
							))}
						</select>
					</div>
				)}
				<div className="lab-in flex-1">
					<label>Label</label>
					<input
						type={"text"}
						value={pointInteret.label}
						onChange={(e) =>
							updatePointInteret("label", e.target.value)
						}
						disabled={!updatePointInteret}
					/>
				</div>
				{openPointInteret && (
					<button
						className={"norm-btn"}
						style={{ marginTop: 24 }}
						onClick={() => openPointInteret(pointInteret)}
					>
						<FontAwesomeIcon icon={faEdit} size={"lg"} />
					</button>
				)}
				<button
					className={"norm-btn"}
					style={{ marginTop: 24 }}
					onClick={() => setShowAdresse((prevState) => !prevState)}
				>
					<FontAwesomeIcon
						icon={showAdresse ? faChevronUp : faChevronDown}
						size={"lg"}
					/>
				</button>
			</div>
			{showAdresse && (
				<AdresseComponent
					adresse={pointInteret.adresse}
					updateAdresse={!updatePointInteret ? null : updateAdresse}
				/>
			)}
		</div>
	)
}

export default PointInteretComponent

export const PointInteretSelect = ({
	pointInteret,
	updatePointInteret,
	list = POINTS_INTERETS.slice(0, 3),
}) => {
	const [selectedType, setSelectedType] = useState(pointInteret.type)
	const [selectedParc, setSelectedParc] = useState(
		pointInteret.type === POINT_INTERET_TYPE_PARC &&
			pointInteret.id !== null
			? pointInteret.id
			: 0,
	)
	const [selectedFourriere, setSelectedFourriere] = useState(
		pointInteret.type === POINT_INTERET_TYPE_FOURRIERE &&
			pointInteret.id !== null
			? pointInteret.id
			: 0,
	)
	const { parcs, fourrieres } = useSelector(
		(state) => state.pointInteretInfo,
	)
	const updateAdresse = (key, value, full = false) => {
		if (full) {
			updatePointInteret("adresse", value)
		} else {
			let tempAdresse = Object.assign({}, pointInteret.adresse)
			tempAdresse[key] = value
			updatePointInteret("adresse", tempAdresse)
		}
	}
	const changeMenu = (newValue) => {
		updatePointInteret("", getBasePointInteret(newValue), true)
		setSelectedType(newValue)
		setSelectedParc(0)
		setSelectedFourriere(0)
	}
	const showParcs = () => {
		const selectParc = (poId) => {
			let tempPo = getBasePointInteret(POINT_INTERET_TYPE_PARC)
			if (poId !== 0) {
				tempPo = Object.assign(
					{},
					parcs.find((p) => p.id === poId),
				)
			}
			updatePointInteret("", tempPo, true)
			setSelectedParc(poId)
		}
		return (
			<div className={"lab-in no-label"}>
				<select
					value={selectedParc}
					onChange={(e) => selectParc(parseInt(e.target.value))}
				>
					<option value={0}>-</option>
					{parcs.map((parc, index) => (
						<option key={`parc_option_${index}`} value={parc.id}>
							{parc.label}
						</option>
					))}
				</select>
			</div>
		)
	}
	const showFourrieres = () => {
		const selectFourriere = (fourriereId) => {
			let tempPo = getBasePointInteret(POINT_INTERET_TYPE_FOURRIERE)
			if (fourriereId !== 0) {
				tempPo = Object.assign(
					{},
					fourrieres.find((p) => p.id === fourriereId),
				)
			}
			updatePointInteret("", tempPo, true)
			setSelectedFourriere(fourriereId)
		}
		return (
			<div className={"lab-in no-label"}>
				<select
					value={selectedFourriere}
					onChange={(e) => selectFourriere(parseInt(e.target.value))}
				>
					<option value={0}>-</option>
					{fourrieres.map((fourriere, index) => (
						<option
							key={`fourriere_option_${index}`}
							value={fourriere.id}
						>
							{fourriere.label}
						</option>
					))}
				</select>
			</div>
		)
	}
	const showAdresse = () => {
		return (
			<AdresseComponentV2
				adresse={pointInteret.adresse}
				updateAdresse={!updatePointInteret ? null : updateAdresse}
			/>
		)
	}
	return (
		<div className={"col flex-center"}>
			<div className="row">
				{list.map((_type, index) => (
					<button
						key={`btn_menu_${Math.random()}`}
						className={`norm-btn4 ${selectedType === _type[0] ? "clicked" : ""}`}
						onClick={() => changeMenu(_type[0])}
					>
						{_type[1]}
					</button>
				))}
			</div>
			{selectedType === POINT_INTERET_TYPE_PARC && showParcs()}
			{selectedType === POINT_INTERET_TYPE_FOURRIERE && showFourrieres()}
			{selectedType === POINT_INTERET_TYPE_ADRESSE && showAdresse()}
		</div>
	)
}

export const POINT_INTERET_TYPE_PARC = 0
export const POINT_INTERET_TYPE_FOURRIERE = 1
export const POINT_INTERET_TYPE_A_VIDE = 2
export const POINT_INTERET_TYPE_SPL = 3
export const POINT_INTERET_TYPE_ADRESSE = 4
export const POINT_INTERET_TYPE_ANNULE = 5
// Coordonnées GPS (Google Maps) : lat/lng dans adresse.extra_data.
export const POINT_INTERET_TYPE_COORDONNEES = 6
// Parc POLICE (GE-13) : parc de dépose appartenant à la police, destination
// « dispo » uniquement. ≠ le POSTE de police (Entite TYPE_POLICE, onglet
// Entités). Miroir de PointInteret.TYPE_POLICE backend.
export const POINT_INTERET_TYPE_POLICE = 7
// Atelier de l'entreprise (GE-69) : destination finale d'un véhicule à
// réparer → fiche atelier « Devis à faire ». Adresse obligatoire. Miroir de
// PointInteret.TYPE_ATELIER backend.
export const POINT_INTERET_TYPE_ATELIER = 8
export const POINTS_INTERETS = [
	[4, "Adresse"],
	[0, "Parc"],
	[1, "Fourrière"],
	[2, "A vide"],
	[3, "S/PL"],
	[5, "Annulé"],
]
export const POINTS_INTERETS_DICT = {
	0: "Parc",
	1: "Fourrière",
	2: "A Vide",
	3: "S/PL",
	4: "Adresse",
	5: "Annulé",
	6: "Coordonnées",
	7: "Parc police",
	8: "Atelier",
}
